import React, { FC, useCallback } from 'react';
import { MainTemplate } from '../../components/layouts';
import { DictionaryWrapper } from '../../components/DictionaryWrapper';
import { DirForeignCity, useForeignCitiesQuery, useForeignCitiesLazyQuery } from '../../api';
import { ForeignCitiesFilter } from '../../components/Filters';
import { Grid, Tooltip } from '@material-ui/core';
import { MUIDataTableColumn } from 'mui-datatables';
import { usePermission } from '../../hooks/usePermission';
import { Link, useHistory } from 'react-router-dom';
import { BtnNew } from '../../components/BtnNew';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { AppStore } from '../../store/reducers';
import { getSettingsUserFilter, getSettingsUserFilterFormValue } from '../../store/selectors/settings';
import { SET_USER_SETTINGS_FILTER } from '../../store/constants';
import { DataTable } from '../../components/DataTable/NewTable';

const Page: FC<{}> = () => {
  const dispatch = useDispatch();
  const filter: any = useSelector((state: AppStore) => getSettingsUserFilter(state, 'foreign_cities'), _.isEqual);
  const formValue: any = useSelector(
    (state: AppStore) => getSettingsUserFilterFormValue(state, 'foreign_cities'),
    _.isEqual,
  );

  const { push } = useHistory();
  const access = usePermission('directory', 'foreign_cities');

  const setFilter = useCallback(
    (filter, form) => {
      dispatch({
        type: SET_USER_SETTINGS_FILTER,
        payload: {
          name: 'foreign_cities',
          filter: filter,
          form,
        },
      });
    },
    [dispatch],
  );

  const columns: MUIDataTableColumn[] = [
    {
      name: 'id',
      label: 'Название',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        customBodyRender: (value: Pick<DirForeignCity, 'id'>, meta: any) => {
          return (
            <React.Fragment>
              <Tooltip title="Перейти в карточку" placement="top-start">
                <Link
                  style={{
                    fontWeight: 500,
                    cursor: 'pointer',
                    textDecoration: 'none',
                  }}
                  to={`/foreign_city/${value}`}
                  target={'_blank'}
                >
                  {meta.rowData[1]}
                </Link>
              </Tooltip>
            </React.Fragment>
          );
        },
      },
    },
    {
      name: 'fullName',
      options: {
        display: false,
      },
    },
    {
      name: 'shortName',
      label: 'Краткое название',
      options: {
        sort: false,
        display: true,
      },
    },
    {
      name: 'dirCountry',
      label: 'Страна',
      options: {
        sort: false,
        display: true,

        customBodyRender: (value: any, meta) => {
          return value.label;
        },
      },
    },
  ];

  return (
    <MainTemplate pageName="Зарубежные города" url="" title="Зарубежные города">
      <ForeignCitiesFilter onSubmit={(filters: any, form: any) => setFilter({ ...filters }, form)} value={formValue} />
      <DictionaryWrapper>
        <DataTable
          tableName="foreign_cities"
          title={
            <React.Fragment>
              <Grid container spacing={2} alignItems={'center'}>
                <Grid item>
                  <h2>Зарубежные города</h2>
                </Grid>
                {access.includes(2) && <Grid item>{<BtnNew onClick={() => push('/foreign_city/new')} />}</Grid>}
              </Grid>
            </React.Fragment>
          }
          lazyQuery={useForeignCitiesLazyQuery}
          filter={filter}
          columns={columns}
        />
      </DictionaryWrapper>
    </MainTemplate>
  );
};

export default Page;
